// extracted by mini-css-extract-plugin
export default {"dataItem":"SensorInfoItem_dataItem__Ql2m3","dataLabel":"SensorInfoItem_dataLabel__UsEni","dataValue":"SensorInfoItem_dataValue__z7h4e"};